export enum DIDRoutingType {
  AiAgent = 1,
  Queue = 2,
  SpecificAgent = 3,
}
